import { ISagaCb } from '@typings/requestPayloads'
import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IRejectMeetingRequestByTokenPayload extends ISagaCb {
    data: {
        token: string
        reason: string
    }
}

export interface IRejectMeetingRequestByTokenState {
    status: string
    data: any
    errors: any
}

const initialState: IRejectMeetingRequestByTokenState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const rejectMeetingRequestByToken = createSlice({
    name: 'meeting-requests/reject-by-token',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IRejectMeetingRequestByTokenPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const rejectMeetingRequestByTokenActions = rejectMeetingRequestByToken.actions
export default rejectMeetingRequestByToken.reducer
